<div class="flex-direction-column gap-10">
  <span class="font-12 weight-600">Categoria</span>

  <div class="flex justify-apace-around align-center cursor-pointer container-menu">
    <button class="none-button" [disabled]="bloqueioTotal" [ngClass]="{ 'container-opcao-selecionada': opcaoSelecionada === 'Marketing' || opcaoSelecionada === 'MARKETING' }" (click)="enviarOpcaoSelecioanda('Marketing')">
      <span class="font-12">Marketing</span>
    </button>
    <button class="none-button" [disabled]="bloqueioTotal" [ngClass]="{ 'container-opcao-selecionada': opcaoSelecionada === 'Utilidade' || opcaoSelecionada === 'Utility' }" (click)="enviarOpcaoSelecioanda('Utility')">
      <span class="font-12">Utilitário</span>
    </button>
    <button class="none-button" [disabled]="bloqueioTotal" [ngClass]="{ 'container-opcao-selecionada': opcaoSelecionada === 'Authentication' || opcaoSelecionada === 'Autenticação' }" (click)="enviarOpcaoSelecioanda('Authentication')">
      <span class="font-12">Autenticação</span>
    </button>
  </div>

</div>
